export default __webpack_public_path__ + "static/media/8.f866e0c9.svg";